import Axios from "axios";

export const SelectNomeEmply = ( a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/NOME?cat=EMP&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({
        type: "NOMEEmpl_SELECT",
        payload: response.data,
      });
    });
  };
};
